package music.jammers.client.shared.event.presentation.mapper

import kotlinx.datetime.number
import music.jammers.client.shared.component.toColor
import music.jammers.client.shared.event.presentation.model.EventListItem
import music.jammers.shared.event.domain.model.Event

class EventListItemMapper {

    fun from(event: Event): EventListItem =
        EventListItem(
            id = event.id,
            title = event.title.uppercase(),
            spot = event.spot,
            day = "${format(event.date.dayOfMonth)}.",
            month = format(event.date.month.number),
            hour = "${format(event.date.hour)}:",
            minutes = format(event.date.minute),
            textColor = event.cardInfo.textColor.toColor(),
            backgroundUrl = event.cardInfo.backgroundUrl,
            readyTracks = event.readyTracks,
            tracksCount = event.tracksCount,
        )

    private fun format(value: Int): String =
        if (value < DECIMAL_VALUE) {
            "0$value"
        } else {
            "$value"
        }

    private companion object {

        const val DECIMAL_VALUE = 10
    }
}